module.exports = __webpack_public_path__ + "static/media/phone.687c9d62.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/icons/phone.svg
// module id = ./src/assets/icons/phone.svg
// module chunks = 0